import { GradeChangeInput } from '@/pages/AccountInformation/AccountInformation.types';
import SignUpForm from './SignUpForm';
import { FormSection, EmailState } from './SignUp.container';

type Props = {
  email: EmailState;
  formSections: FormSection[];
  lookUpSchools: (options: any, callback: any) => void;
  onSchoolChange: (value: any, sectionId: string, fieldId: string) => void;
  onGradeChange: (
    input: GradeChangeInput,
    sectionId: string,
    fieldId: string,
  ) => void;
  onEmailChange: (value: string) => void;
  handleSubmit: (event: Event) => void;
  onAddChild: () => void;
  onRemoveChild: (sectionId: string) => void;
};

const ParentSignUp: React.FunctionComponent<Props> = ({
  email,
  formSections,
  handleSubmit,
  onGradeChange,
  onEmailChange,
  lookUpSchools,
  onSchoolChange,
  onAddChild,
  onRemoveChild,
}) => (
  <SignUpForm
    email={email}
    formSections={formSections}
    lookUpSchools={lookUpSchools}
    handleSubmit={handleSubmit}
    onGradeChange={onGradeChange}
    onEmailChange={onEmailChange}
    onSchoolChange={onSchoolChange}
    onAddChild={onAddChild}
    onRemoveChild={onRemoveChild}
  />
);

export default ParentSignUp;
